import Icon from "Core/components/display/Icon";

export const iconSymbol = 'youtube-play';
export const iconSymbolPrefix = 'icofont-';
/**
 * Rendered icon element used as a page icon
 * @description Page icons can be used in main navigation, page links and buttons or any other place.
 * @type {JSX.Element}
 */
export const iconElement = <Icon symbol={iconSymbol} symbolPrefix={iconSymbolPrefix} />

/**
 * Page router path relative to the base path of the app
 * @note Use '/' at the beginning (for example '/home').
 * @type {string}
 */
export const routerPath = `/videohelp`;

/**
 * Page translation path
 * @type {string}
 */
export const translationPath = `HelpVideosPage`;